import { lazy } from 'react';

// Resolve React.lazy synchronously after an idle preload has finished. Merely
// importing the chunk still makes a new lazy component suspend for one tick.
export function lazyHouseholdPage(importPage) {
    let loaded;
    let pending;
    const preload = () => {
        if (!pending) {
            pending = importPage().then((module) => {
                loaded = module;
                return module;
            }).catch((error) => {
                pending = undefined;
                throw error;
            });
        }
        return pending;
    };
    const Page = lazy(() => loaded ? { then: (resolve) => resolve(loaded) } : preload());
    return { Page, preload };
}
